/**
 * 今日日付をyyyy-mm-dd形式で返却する.
 *
 * 引数で今日から何日後を取得したいか指定することができる.
 * @param {number} daysAfter 今日から何日後の日付を取得するか
 * @returns 指定された日付
 */
export const getToday = (daysAfter?: number) => {
  const date = new Date();
  date.setDate(date.getDate() + (daysAfter ?? 0));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
